"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks to see if the value is null or udefined
 *
 * @export
 * @param {*} value Value to check
 * @returns {boolean} true if it's null or udefined else false
 */
function isNullOrUndefined(value) {
    return value === null || isUndefined(value);
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 * Will validate the passed parameter against isNullOrUndefined, isObjectAndEmpty, isArrayAndEmpty, isStringAndEmpty
 *
 * @export
 * @param {(any[] | undefined)} collection
 * @returns {boolean}
 */
function isNullOrEmpty(value) {
    return isNullOrUndefined(value) || isStringAndEmpty(value) || isArrayAndEmpty(value) || isObjectAndEmpty(value);
}
exports.isNullOrEmpty = isNullOrEmpty;
function isUndefined(value) {
    return value === void 0;
}
exports.isUndefined = isUndefined;
/**
 * Will return a boolean indicating wether the passed variable is an object
 *
 * @export
 * @param {any} obj
 * @returns {boolean}
 */
function isObject(obj) {
    return (typeof obj === 'object' && !Array.isArray(obj));
}
exports.isObject = isObject;
/**
 * Validates if the parameter is of type string and if it is null or whitespace
 *
 * @export
 * @param {any} value
 * @returns {boolean}
 */
function isStringAndEmpty(value) {
    return typeof value === 'string' && isNullOrWhitespace(value);
}
exports.isStringAndEmpty = isStringAndEmpty;
/**
 * Checks if a string is null or whitespace.
 *
 * @export
 * @param {string} value to check if the value is null or whitespace
 * @returns {boolean} true if it's null, undefined, empty or whitespace else false
 */
function isNullOrWhitespace(value) {
    var type = typeof value;
    if (type === 'boolean' || type === 'number') {
        value = value.toString();
    }
    return (value || '').trim() === '';
}
exports.isNullOrWhitespace = isNullOrWhitespace;
/**
 * Will validate if the parameter is of type array and if it is empty
 *
 * @export
 * @param {any} array
 * @returns {boolean}
 */
function isArrayAndEmpty(array) {
    return !isNullOrUndefined(array) && Array.isArray(array) && array.length === 0;
}
exports.isArrayAndEmpty = isArrayAndEmpty;
/**
 * Will validate if the passed parameter is of type object and has no properties defined
 *
 * @param {{}} obj
 * @returns {boolean}
 */
function isObjectAndEmpty(obj) {
    if (!isObject(obj)) {
        return false;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
}
exports.isObjectAndEmpty = isObjectAndEmpty;
/**
 * Will validate if the passed parameter is NaN
 *
 * @param {any} value
 * @returns {boolean}
 */
function isNaN(value) {
    if (value instanceof Number) {
        var numberValue = value.valueOf();
        return Number.isNaN(numberValue);
    }
    return Number.isNaN(value);
}
exports.isNaN = isNaN;
/**
 * Will validate if the passed parameter is a number
 *
 * @param {any} value
 * @returns {boolean}
 */
function isNumber(value) {
    return Number(value) === parseFloat(value) && (value instanceof Number || typeof (value) === 'number');
}
exports.isNumber = isNumber;
/**
 * Will validate if the passed parameter is a date
 *
 * @param {any} value
 * @returns {boolean}
 */
function isDate(value) {
    return (value instanceof Date);
}
exports.isDate = isDate;
/**
 * Will return a boolean indicating whether the passed string is a valid base64 image
 *
 * @export
 * @param {any} obj
 * @returns {boolean}
 */
function isBase64File(value) {
    value = value && value.trim();
    var base64Regex = /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*)$/i;
    return base64Regex.test(value);
}
exports.isBase64File = isBase64File;
//# sourceMappingURL=typeChecks.js.map